<template>
  <div class="data-analysis">
    <el-card shadow="never">
      <div style="margin: 6px; font-size: 20px">
        平台概况

        <el-tooltip class="item" effect="dark" content="历史数据" placement="top">
          <i style="float: right; cursor: pointer" class="el-icon-data-analysis" @click="GoHistory"></i>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="计算" placement="top">
          <i v-if="false" style="float: right; cursor: pointer; margin-right: 20px" class="el-icon-refresh" @click="adminCreateSysTotalInfo"></i>
        </el-tooltip>
      </div>

      <el-row style="margin-top: 20px" :gutter="12">
        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>体验校区</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.try_school_num }}</span>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>合作校区</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.school_num }}</span>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>员工数量</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.user_num }}</span>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>激活时长</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.school_use_stu_time_num }}</span>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>试听班</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.try_class_num }}</span>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>正式班</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.normal_class_num }}</span>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>意向学员</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.intended_stu_num }}</span>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>试听学员</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.try_stu_num }}</span>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>教师上课记录</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.signed_tchplan_num }}</span>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>学生上课记录</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.signed_stu_tchplan_num }}</span>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>在读学员</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: #5470c6; font-weight: bold">{{ latestSysTotalInfo.normal_stu_num }}</span>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="card_data" shadow="hover">
            <div style="text-align: center">
              <h1>更新时间</h1>
            </div>
            <div style="text-align: center; margin: 10px">
              <span style="font-size: 18px; color: green">{{
                latestSysTotalInfo.created_time
              }}</span>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>

    <el-card shadow="never" style="margin-top: 10px">
      <div style="margin: 6px; font-size: 20px">课程概况</div>

      <el-row style="margin-top: 20px">
        <el-col :span="12">
          <div>
            <div style="width: 100%; height: 300px" id="myChart2"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <div style="width: 100%; height: 300px" id="myChart3"></div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {
  adminCreateSysTotalInfo,
  adminGetLatestSysTotalInfo,
  adminGetStuNumBySubject,
  adminGetSchoolNumBySchoolSubject,
} from "@/api/admin";

export default {
  name: "data-analysis",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      value2: "",

      //数据看板
      latestSysTotalInfo: {},

      //课程概况
      data_x_stu: [],
      data_y_stu: [],
      //数据看板
      myChart2: {}, //在读学员
      myChart3: {}, //员工数
      StulistBySubject: [],

      data_x_school: [],
      data_y_school: [],
      SchoollistBySubject: [],
    };
  },
  computed: {},
  mounted() {

    if (this.$store.getters.adminToken) {
      this.adminGetLatestSysTotalInfo();
      this.adminGetStuNumBySubject();
      this.adminGetSchoolNumBySchoolSubject();
    }
  },
  methods: {
    //计算平台概况
    adminCreateSysTotalInfo() {
      adminCreateSysTotalInfo().then((res) => {
        console.log("计算平台概况");
        console.log(res);
        if (res.is_create) {
          this.$message.success("数据统计完成");
          this.adminGetLatestSysTotalInfo();
        }
      });
    },

    //平台最新概况
    adminGetLatestSysTotalInfo() {
      adminGetLatestSysTotalInfo().then((res) => {
        console.log("平台概况");
        console.log(res);
        this.latestSysTotalInfo = res.latestSysTotalInfo;
      });
    },

    //根据科目权限查询校区人数
    adminGetStuNumBySubject() {
      adminGetStuNumBySubject().then((res) => {
        console.log("根据科目统计学员");
        console.log(res);
        this.StulistBySubject = res.schoolNumList;

        this.data_x_stu = [];
        this.data_y_stu = [];

        for (let k = 0; k < this.StulistBySubject.length; k++) {
          this.data_x_stu.push(this.StulistBySubject[k].subjectInfo.name);
          this.data_y_stu.push(this.StulistBySubject[k].count);
        }

        console.log(this.data_x_stu);
        console.log(this.data_y_stu);

        this.$nextTick(function () {
          this.drawLine2();
          //this.getStaff();
          //this.getTime();
        });
      });
    },

    //根据科目权限查询校区人数
    adminGetSchoolNumBySchoolSubject() {
      adminGetSchoolNumBySchoolSubject().then((res) => {
        console.log("根据科目统计学校");
        console.log(res);
        this.SchoollistBySubject = res.schoolNumList;

        this.data_x_school = [];
        this.data_y_school = [];

        for (let k = 0; k < this.SchoollistBySubject.length; k++) {
          this.data_x_school.push(this.SchoollistBySubject[k].subjectInfo.name);
          this.data_y_school.push(this.SchoollistBySubject[k].count);
        }

        console.log(this.data_x_school);
        console.log(this.data_y_school);

        this.$nextTick(function () {
          this.getStaff();
          // this.getTime();
        });
      });
    },

    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        title: { text: "" },
        tooltip: {},
        xAxis: {
          data: [
            "2021-11-1",
            "2021-11-2",
            "2021-11-3",
            "2021-11-4",
            "2021-11-5",
            "2021-11-6",
            "2021-11-7",
            "2021-11-8",
            "2021-11-9",
            "2021-11-10",
            "2021-11-11",
            "2021-11-12",
            "2021-11-1",
            "2021-11-2",
            "2021-11-3",
            "2021-11-4",
            "2021-11-5",
            "2021-11-6",
            "2021-11-7",
            "2021-11-8",
            "2021-11-9",
            "2021-11-10",
            "2021-11-11",
            "2021-11-12",
          ],
        },
        yAxis: {},
        series: [
          {
            name: "试听课",
            type: "bar",
            data: [
              2, 10, 16, 10, 10, 10, 5, 20, 26, 10, 10, 20, 2, 10, 16, 10, 10,
              10, 5, 20, 26, 10, 10, 20,
            ],
          },
          {
            name: "常规课",
            type: "bar",
            data: [
              5, 20, 36, 10, 10, 20, 5, 20, 36, 10, 10, 20, 2, 10, 16, 10, 10,
              10, 5, 20, 26, 10, 10, 20,
            ],
          },
        ],
      });
    },

    drawLine2() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart2 = this.$echarts.init(document.getElementById("myChart2"));
      // 绘制图表
      this.myChart2.setOption({
        title: { text: "学员分布" },
        tooltip: {},
        xAxis: {
          data: this.data_x_stu,
        },
        yAxis: {},
        series: [
          {
            name: "学员数",
            type: "bar",
            data: this.data_y_stu,
          },
        ],
      });

      var that = this;

      this.myChart2.on("click", function (params) {
        console.log(params.name);
        that.$message.success(params.name);
      });
    },

    getStaff() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart3 = this.$echarts.init(document.getElementById("myChart3"));
      // 绘制图表
      this.myChart3.setOption({
        title: { text: "学校分布" },
        tooltip: {},
        xAxis: {
          data: this.data_x_school,
        },
        yAxis: {},
        series: [
          {
            name: "校区数",
            type: "bar",
            data: this.data_y_school,
          },
        ],
      });

      var that = this;

      this.myChart3.on("click", function (params) {
        console.log(params.name);
        that.$message.success(params.name);
      });
    },

    GoHistory() {
      this.$router.push({
        name: "history",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.data-analysis {
  height: 100%;
  margin: 10px;
  .card_data {
    margin-bottom: 20px;
  }
}
</style>
